import React from 'react';
import Page from 'spark-ui/ui-kitchen/ingredients/base/Page';
import GapPacketForm from './form/GapPacketForm';
import RecipientResultGrid from './common/RecipientResultGrid';
import Permission from 'spark-util/Permission';
import AcknowledgeGapPacketPopup from './common/AcknowledgeGapPacketPopup';
import TemporaryRoute from 'spark-util/TemporaryRoute';


const GapPacketRecipientHome = () => (
	<Page title="Acknowledge Gap Packets">
		{/* SAF-20237: Removed temporary ibCLSafetyRecipient prop (Role Assignment - Switch Roles and its Precedence - PSR-4763) */}
		<Permission recipientOnly>
			<GapPacketForm gridName='GapPacketRecipientResultsGrid'/>
			<RecipientResultGrid gridName='GapPacketRecipientResultsGrid'/>
			<TemporaryRoute
                        name="AcknowledgeGapPacket"
						render={({ goBack, params }) => <AcknowledgeGapPacketPopup closeDialog={goBack}  gapPacketId={ params && params.gapPacketId ? params.gapPacketId : null} />}
                    />
		</Permission>
	</Page>
);

export default GapPacketRecipientHome;